// eslint-disable-next-line import/prefer-default-export
export const download = {
  methods: {
    download({ data, filename, encoding = 'UTF-8', type = 'text/csv;charset=UTF-8' }) {
      const fileURL = window.URL.createObjectURL(
        new Blob([data], {
          encoding,
          type,
        }),
      );
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;

      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },
};
